var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"bl-backdrop"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bl-centered"},[_c('i',{staticClass:"fa fa-spinner fa-spin inner-loading"})])
}]

export { render, staticRenderFns }